<template>
  <v-dialog v-model="inviteDialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn right class="my-4" color="primary" v-on="on">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("company.tabs.administrators.button.title") }}
      </v-btn>
    </template>
    <v-card v-if="!finished">
      <v-card-title class="headline primary white--text" primary-title>{{
        $t("company.tabs.administrators.button.modal_title")
      }}</v-card-title>

      <v-card-text class="mt-2">
        {{ $t("company.tabs.administrators.button.description") }}
        <v-text-field v-model="inviteEmail" :label="$t('common.email')"></v-text-field>
        <p class="red--text" v-if="feedback">{{ feedback }}</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog()">{{ $t("common.cancel") }}</v-btn>
        <v-btn color="primary" :loading="isInviting" @click="inviteUser()">{{
          $t("common.send")
        }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline primary white--text" primary-title>{{
        $t("common.success")
      }}</v-card-title>
      <v-card-text class="mt-2"
        >{{
          $t("company.tabs.administrators.button.success_message", {
            user: inviteEmail,
          })
        }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog()">{{ $t("common.close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import functions from "@/firebase/functions";

export default {
  name: "InviteAdmin",
  props: ["company"],
  data() {
    return {
      inviteDialog: false,
      isInviting: false,
      inviteEmail: "",
      feedback: null,
      finished: false,
    };
  },
  methods: {
    closeDialog() {
      this.inviteDialog = false;
      this.finished = false;
      this.inviteEmail = "";
      this.isInviting = false;
    },
    inviteUser() {
      console.log("inviting user:", this.inviteEmail);
      const isEmailValid = /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}/.test(
        this.inviteEmail,
      );

      if (!isEmailValid) {
        this.feedback = this.$t("common.error.validEmail");
        return;
      }

      this.feedback = null;
      // let company = this.$store.state.company;
      const { company } = this.$props;
      this.isInviting = true;
      functions
        .sendCompanyInvite({
          companyId: company.id,
          emails: [this.inviteEmail.toLowerCase()],
          companyName: company.name,
        })
        .then((result) => {
          console.log(result);
          this.isInviting = false;
          this.finished = true;
        })
        .catch((error) => {
          const { message } = error;
          this.isInviting = false;
          this.feedback = message;
        });
    },
  },
};
</script>
